import { useMutation } from '@tanstack/vue-query';
import { dscvrIcApi } from '@/shared/api';

export const useDeleteContentMutation = () => {
  return useMutation({
    mutationKey: ['delete-content-mutation'],
    mutationFn: (contentId: bigint) => dscvrIcApi.post.deleteContent(contentId),
  });
};
